<template>
  <div :class="['chapter-description fake-section', { large: screenParams.large, margined: !app.deviceIsDesktop && screenParams.margined }]">
    <input-field class="hidden-input" />
    <div class="jumbotron" :style="{backgroundImage: screenParams.jumbotronPicture ? `url(${isLargeDesktop && screenParams.jumbotronPictureDesktop ? screenParams.jumbotronPictureDesktop :  screenParams.jumbotronPicture})` : ''}"></div>

    <div class="content">
      <h2 class="header">{{screenParams.header($store)}}</h2>
      <p class="description">{{screenParams.description($store)}}</p>

      <div class="button-container">
        <button id="chapterDescription" class="continue" :class="{active: isSaving}" @click="goToNextScreen">
          <spinner v-if="isSaving" type="ring" class="custom-spinner" />
          <span v-else>{{ screenParams.buttonText($store) }}</span>
        </button>
        <button v-if="screenParams.secondaryOption" class="link" @click.prevent="secondaryOptionClicked" v-html="screenParams.secondaryOption.text($store)"></button>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import Mousetrap from 'mousetrap'
  export default {
    props: ['screenParams'],
    data () {
      return {
        isSaving: false
      }
    },
    computed: {
      ...mapState(['app']),
      isLargeDesktop () {
        return this.app.deviceIsDesktop && (window.innerWidth >= 1024 || this.screenParams.large)
      }
    },
    mounted () {
      document.querySelector('.continue').focus()
      Mousetrap.bind('enter', () => {
        let next = document.querySelector('.continue')
        if (next) {
          next.click()
        }
        return false
      })
    },
    methods: {
      goToNextScreen () {
        this.isSaving = true
        if (this.screenParams.showKeyboardOnNextScreen) {
          const input = this.$el.querySelector('input')
          if (input) {
            input.focus()
          }
        }
        if (this.screenParams.primaryAction) {
          this.screenParams.primaryAction(this.$store, {description: this.i18n.t('base:idin_api_description')})
        } else {
          this.$store.dispatch('next', { ...this.screenParams.nextScreenRoute, skipDelay: true })
        }
      },

      secondaryOptionClicked () {
        if (this.screenParams.secondaryOption.action) {
          this.screenParams.secondaryOption.action(this.$store)
        }
        this.$store.dispatch('next', { ...this.screenParams.nextScreenRoute, skipDelay: true })
      }
    }
  }
</script>


<style lang="scss" scoped>
  @import '../assets/mixins.scss';

  .chapter-description {
    display: flex;
    flex-direction: column;
    align-content: center;
    flex: 1;
    margin: -30px;
    text-align: center;
    position: relative;
    background: #fff;

    @include desktop-big {
      margin-top: -80px;
    }
    

    .jumbotron {
      height: 240px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;

      @include desktop {
        height: 190px;
        border-radius: 12px;
        margin: 16px 16px 0;
      }

      @include desktop-big {
        margin-left: -74px;
        margin-right: -74px;
        margin-top: 16px;
        height: 240px;
      }
    }

    @include desktop {
      &.large {
        margin: 0;
  
        .jumbotron {
          margin: 0;
          border-radius: 0;
        }
      }
    }

    &.margined {
      .jumbotron {
        height: 179px;
        border-radius: 0;
      }

      .content {
        max-width: 260px;

        .continue {
          max-width: 240px;
          height: 56px;
        }
      }
    }

    .content {
      display: flex;
      flex-direction: column;
      align-items: center;
      flex-grow: 2;
      padding: 0 20px;
      max-width: 420px;
      width: 100%;
      margin: 0 auto;
      box-sizing: border-box;
    }

    .header {
      color: #161616;
      font-size: 26px;
      font-weight: bold;
      line-height: 27px;
      font-family: $mainFontFamily;
      margin: auto auto 20px auto;
      white-space: pre-line;
      @include desktop {
        margin: 30px auto 15px auto;
      }

      @include desktop-big {
        margin-top: 60px;
        margin-bottom: 20px;
      }

      @include small-phone {
        margin-bottom: 10px;
      }
    }

    .description {
      color: #798291;
      font-family: $hintFontFamily;
      font-weight: $lightFontWeight;
      font-size: 15px;
      line-height: 22px;
      white-space: pre-line;
      margin-bottom: 10px;
      text-align: center;
      max-width: 310px;
      margin: 0 auto;

      @include desktop {
        width: 100%;
        max-width: 100%;
      }
    }

    .secondary-option {
      color: #000000;
      margin-top: 10px;
      margin-bottom: 10px;
    }

    .button-container {
      text-align: center;
      margin: auto 0 30px;
      width: 100%;

      @include long-phone {
        margin-bottom: 60px;
      }
      @include desktop {
        margin-bottom: 30px;
      }

      @include desktop-big {
        margin-bottom: 30px;
      }

      .continue {
        @include hide-button-outline;
        height: 60px;
        width: 100%;
        border: none;
        font-weight: 400;
        line-height: 23px;
        border-radius: $buttonBorderRadius;
        background-color: $buttonPrimaryBackgroundColor;
        font-family: $mainFontFamily;
        color: $buttonPrimaryColor;
        font-weight: $buttonPrimaryWeight;
        font-size: $buttonPrimarySize;
        position: relative;

        @include small-phone {
          height: 60px;
        }
      }
      .link {
        margin-top: 10px;
        color: #798291;
        text-decoration: underline;
        font-size: 15px;
        box-shadow: none;
        font-weight: $lightFontWeight;
      }
    }

    .hidden-input {
      top: -1000px;
      position: absolute;
    }
  }
</style>


// WEBPACK FOOTER //
// src/screens/ChapterDescription.vue